/* global $ */
import { _ } from '../utils.js'

export default class Search {
    constructor(el) {
        this.listingForm = $(el)
        this.type = this.listingForm.data('type')
        this.resultsContainer = this.listingForm.find(
            _('results-container', 'element').str(),
        )
        this.filter = this.listingForm.find(_('filter', 'element').str())
        this.filterSearch = this.listingForm.find(_('search').str())

        this.csrf = this.listingForm
            .find(_('search-csrf', 'element').str())
            .val()
        this.textInput = this.listingForm.find(_('text-input', 'element').str())
        this.loadMore = this.listingForm.find(_('load-more', 'element').str())
        this.next = _('next-page', 'element').node()
        this.prev = _('previous-page', 'element').node()
        this.paginationSelect = _('select-page', 'element').node()
        this.inputPage = this.listingForm.find(_('input-page', 'element').str())
        this.loadingMarkup =
            '<div class="loading" data-element="loading-icon"><div class="loading__circle"></div><div class="loading__circle"></div></div>'
        this.loadMore.on('click', this.loadMoreContent)
        if (this.next) {
            this.next.addEventListener('click', () => {
                this.loadMoreContent('next')
            })
            this.prev.addEventListener('click', () => {
                this.loadMoreContent('prev')
            })
            this.paginationSelect.addEventListener('change', (e) => {
                this.loadMoreContent(e.target.value)
            })
        }

        this.unwrap = this.listingForm.data('unwrap')
    }

    loadMoreContent = (context) => {
        let page = this.inputPage.val()
        // set the new page
        if (context !== page || typeof context !== 'number') {
            const totalPages = this.totalPages || page + 1
            if (context === 'next' && page <= totalPages) {
                this.inputPage.val(parseFloat(page) + 1)
            } else if (context === 'prev' && page > 1) {
                this.inputPage.val(parseFloat(page) - 1)
            } else {
                this.inputPage.val(context)
            }
            window.scroll(0, 0)
            // change pagination controls
            page = this.inputPage.val()

            // set disabled attributes
            if (page > 1) {
                this.prev.disabled = false
            } else {
                this.prev.disabled = true
            }
            if (page === this.totalPages) {
                this.next.disabled = true
            } else {
                this.next.disabled = false
            }

            this.paginationSelect.value = page

            this.getResults(false)
        }
    }

    getResults = (loadmore) => {
        let filtersValue = ''
        this.filters = this.filter.map((i, el) => {
            filtersValue += `&${el.getAttribute('name')}=${el.value}`
        })

        if (this.filterSearch.length) {
            filtersValue += `&${this.filterSearch.attr(
                'name',
            )}=${this.filterSearch.val()}`
        }

        if (this.textInput.length) {
            this.textInput.map((i, el) => {
                filtersValue += `&${el.getAttribute('name')}=${el.value}`
            })
        }

        if (loadmore !== true) {
            this.resultsContainer.html(this.loadingMarkup)
        } else {
            this.resultsContainer.append(this.loadingMarkup)
        }

        const apiUrl = this.listingForm.data('action') || ''

        const endpoint = `${apiUrl}?ccm_token=${
            this.csrf
        }&page=${this.inputPage.val()}${filtersValue}`

        $.ajax({
            headers: {
                csrf: this.csrf,
            },
            type: 'get',
            url: endpoint,
            dataType: 'json',
            contentType: 'application/json',
            success: (data) => {
                _('loading-icon', 'element').node().remove()
                if (this.unwrap) {
                    this.resultsContainer.html(
                        `<div data-element="loaded" class=
                            "grid grid--4-col ${
                                this.resultsContainer.data('remove-margin')
                                    ? ''
                                    : 'u-mb-half'
                            } grid--break-2@large grid--break@medium grid--equal-height">${
                                data.html
                            }</div>`,
                    )
                } else {
                    this.resultsContainer.html(
                        `<div data-element="loaded" class="section u-pt0 u-pb">${data.html}</div>`,
                    )
                }
                this.totalPages = data.paginationData.totalPages
                this.loadMore.toggle(
                    data.paginationData.totalPages !==
                        data.paginationData.currentPage,
                )
            },
            error: (data) => {
                this.resultsContainer.html(data.html)
            },
        })
    }
}
